<script>
import { sync } from 'vuex-pathify'
const { ProductPromoType } = require('#/shop-catalog/services/product-promo-constants')
import formatPrice from '@/v-shop/helpers/format-price'

export default {
	lang: 'shop',
	props: {
		product: Object,
		variant: Object,
		promos: Array,
		customization: Object,
	},
	computed: {
		ctaIsLoading: sync('shop/ctaIsLoading'),
		outOfStock() {
			return this.variant?.stock.availability == 'OutOfStock'
		},
		price() {
			return this.variant?.pvPrice.price
		},
		currency() {
			return this.variant?.pvPrice.priceConfig.currency.sign
		},
		maxStockQty() {
			let { maxBuyableQty, infiniteQty, qty } = this.variant.stock
			if (maxBuyableQty >= 1) {
				if (infiniteQty) return maxBuyableQty
				else return Math.min(qty, maxBuyableQty)
			} else {
				if (infiniteQty) return 0
				else return qty
			}
		},
	},
	methods: {
		async onCtaClick(qty) {
			return this.$shop.addToCart({
				productId: this.product.id,
				variantId: this.variant.id,
				qty,
				sum: true,
				customization: this.customization,
				loading: (v) => (this.ctaIsLoading = v),
				onValidation: ({ validation }) => this.$emit('validation', validation),
			})
		},
		getCtas(promo) {
			if (!promo.cta) return []

			let ctas = []
			if (promo.type == ProductPromoType.BUY_X_RECEIVE_Y) {
				ctas = promo.data.configs
					.map((config) => ({ ...config }))
					.sort((a, b) => a.x - b.x)
					.map((config) => {
						return {
							data: { ...config, unitPrice: (this.price * Number(config.x)) / Number(config.y) },
							addQty: Number(config.x),
						}
					})
			} else if (promo.type == ProductPromoType.BUY_X_PAY_Y) {
				ctas = promo.data.configs
					.map((config) => ({ ...config }))
					.sort((a, b) => a.x - b.x)
					.map((config) => {
						return {
							data: { ...config, unitPrice: (this.price * Number(config.y)) / Number(config.x) },
							addQty: Number(config.x),
						}
					})
			} else if (promo.type == ProductPromoType.SAMPLING) {
				ctas = [
					{
						data: {},
						addQty: Number(promo.data.x || 1),
					},
				]
			} else if (promo.type == ProductPromoType.DISCOUNT_ON_X) {
				ctas = [
					{
						data: {
							unitPrice:
								(this.price * Number(promo.data.x) -
									(this.price * Number(promo.data.discountPct)) / 100) /
								Number(promo.data.x),
						},
						addQty: Number(promo.data.x),
					},
				]
			} else if (promo.type == ProductPromoType.DISCOUNT_AFTER_X) {
				ctas = [
					{
						addQty: Number(promo.data.x),
					},
				]
			}

			const money = (amount, opts = {}) => {
				return (
					'<span class="nowrap">' +
					formatPrice(amount, {
						currency: this.currency,
						...opts,
					}) +
					'</span>'
				)
			}

			ctas.forEach((cta) => {
				let data = { ...promo.data, ...cta.data, money }
				cta.text = promo.cta ? this.evalPromoText(data, promo.cta) : null
				cta.subText = promo.subCta ? this.evalPromoText(data, promo.subCta) : null
			})

			return ctas
		},
		evalPromoText(fnVars, text) {
			try {
				return text
					.replace(/{{(.*?)}}/g, (_, expression) => {
						let fnStr = `
							let { ${Object.keys(fnVars).join(', ')} } = fnVars
							return ${expression}
						`
						let func = new Function('fnVars', fnStr)
						return func(fnVars)
					})
					.trim()
			} catch (error) {
				return ''
			}
		},
	},
}
</script>

<template>
	<div id="product-promos" class="d-flex flex-column" style="gap: 12px">
		<div
			v-for="promo in promos"
			:key="promo.id"
			class="promo-item pa-3 grey lighten-4 rounded d-flex flex-column"
			style="gap: 8px; border: 1px solid #bbb !important"
		>
			<div class="d-flex align-center" style="gap: 8px">
				<v-icon color="var(--cta)" size="28" class="flex-shrink-0">mdi-star</v-icon>
				<div>
					<div class="font-1 font-weight-bold">{{ promo.name }}</div>
					<div
						class="font-0 grey--text text--darken-2"
						v-html="promo.message"
						v-if="promo.message"
					></div>
				</div>
			</div>
			<Button
				v-for="(cta, i) in getCtas(promo)"
				:key="i"
				class="w100"
				color="cta"
				:disabled="outOfStock || !product.buyable"
				:loading="ctaIsLoading"
				@click="onCtaClick(cta.addQty)"
				outlined
				style="height: unset; padding: 10px"
			>
				<div>
					<div class="d-flex align-center justify-center">
						<v-icon class="font-0 mr-2">mdi-cart-outline</v-icon>
						<span class="font-2" v-html="cta.text"></span>
					</div>
					<div v-if="cta.subText" class="font-0" v-html="cta.subText"></div>
				</div>
			</Button>
		</div>
	</div>
</template>

